import PropTypes from 'prop-types'
import React from 'react'
import { Box, Grid, Flex } from 'components/Layout'
import ProgressIndicator from 'components/ProgressIndicator'
import { Text } from 'components/Typography'
import { COLOR, FONT_SIZE, SPACE } from 'Theme'

export const GroupSessionInfo = ({
  sessionCapacity,
  confirmedParticipantsCount,
}) => (
  <Grid
    gridTemplateColumns={{
      MOBILE: 'auto 1fr',
      TABLET: `${SPACE.PX_40} auto`,
    }}
    gridGap={SPACE.PX_5}
  >
    <Flex justifyContent="flex-end">
      <ProgressIndicator
        percentage={(100 / sessionCapacity) * confirmedParticipantsCount}
      />
    </Flex>
    <Flex flexDirection="column">
      <Flex
        flexDirection={{
          MOBILE: 'row',
          TABLET: 'column',
          DESKTOP: 'row',
        }}
        flexWrap="wrap"
      >
        <Box>
          <Text>{`${confirmedParticipantsCount} confirmed`}</Text>
        </Box>
        {confirmedParticipantsCount !== sessionCapacity && (
          <Box
            ml={{
              MOBILE: SPACE.PX_5,
              TABLET: 0,
              DESKTOP: SPACE.PX_5,
            }}
          >
            <Text color={COLOR.SECONDARY_1}>
              {`(${sessionCapacity - confirmedParticipantsCount} remaining)`}
            </Text>
          </Box>
        )}
      </Flex>
      <Text fontSize={FONT_SIZE.PX_12} color={COLOR.GRAYSCALE_3}>
        {`${confirmedParticipantsCount} to ${sessionCapacity} capacity`}
      </Text>
    </Flex>
  </Grid>
)

GroupSessionInfo.propTypes = {
  sessionCapacity: PropTypes.number.isRequired,
  confirmedParticipantsCount: PropTypes.number.isRequired,
}
